/**
 * Bulk submission rules the client needs before it asks the server.
 *
 * Server twin: `Core/Common/BuyerSubmissionRemovalRules.cs`. Pinned by the shared
 * fixture `tests/fixtures/buyer-submission-bulk-rules.json`, read by both suites.
 * The server stays authoritative — it refuses a larger set and returns its own
 * reasons; these only keep the client from offering what it would refuse.
 */

/** D14: most listings one PRESENT ALL SELECTED may present. */
export const MAX_PRESENT_PER_ACTION = 50;
